export const suggestedBanners = [
  'https://minio-api.apps.konnectbd.com/konnect/C%2010.png-ZTpZr',
  'https://minio-api.apps.konnectbd.com/konnect/C%2011.png-LLvpg',
  'https://minio-api.apps.konnectbd.com/konnect/C%2012.png-HlZEK',
  'https://minio-api.apps.konnectbd.com/konnect/C%2013.png-ViUQE',
  'https://minio-api.apps.konnectbd.com/konnect/C%2014.png-ZdXLg',
  'https://minio-api.apps.konnectbd.com/konnect/C%2015.png-ugApu',
  'https://minio-api.apps.konnectbd.com/konnect/C%2016.png-JmVfB',
  'https://minio-api.apps.konnectbd.com/konnect/C%2017.png-TUuQt',
  'https://minio-api.apps.konnectbd.com/konnect/C%2018.png-eSpIV',
  'https://minio-api.apps.konnectbd.com/konnect/C%2019.png-rrNMg',
  'https://minio-api.apps.konnectbd.com/konnect/C%201.png-uQkZn',
  'https://minio-api.apps.konnectbd.com/konnect/C%202.png-WeTlo',
  'https://minio-api.apps.konnectbd.com/konnect/C%203.png-iVjQa',
  'https://minio-api.apps.konnectbd.com/konnect/C%204.png-TJZwh',
  'https://minio-api.apps.konnectbd.com/konnect/C%205.png-HMZoA',
  'https://minio-api.apps.konnectbd.com/konnect/C%206.png-lXvNE',
  'https://minio-api.apps.konnectbd.com/konnect/C%207.png-nIRZG',
  'https://minio-api.apps.konnectbd.com/konnect/C%208.png-CNGFU',
  'https://minio-api.apps.konnectbd.com/konnect/C%209.png-Ehngt',
  'https://minio-api.apps.konnectbd.com/konnect/K01.jpg-zMCIJ',
  'https://minio-api.apps.konnectbd.com/konnect/K02.jpg-uYtDU',
  'https://minio-api.apps.konnectbd.com/konnect/K03.jpg-ITGFo',
  'https://minio-api.apps.konnectbd.com/konnect/K04.jpg-svgGF',
  'https://minio-api.apps.konnectbd.com/konnect/K05.jpg-XBKPE',
  'https://minio-api.apps.konnectbd.com/konnect/K07.jpg-BiHeN',
  'https://minio-api.apps.konnectbd.com/konnect/K09.jpg-SpIIw',
  'https://minio-api.apps.konnectbd.com/konnect/K10.jpg-fZVtX',
  'https://minio-api.apps.konnectbd.com/konnect/K11.jpg-iytXI',
  'https://minio-api.apps.konnectbd.com/konnect/K12.jpg-QONsA',
  'https://minio-api.apps.konnectbd.com/konnect/K13.jpg-XFpjM',
  'https://minio-api.apps.konnectbd.com/konnect/K14.jpg-MnQen',
  'https://minio-api.apps.konnectbd.com/konnect/K15.jpg-aqCRS',
  'https://minio-api.apps.konnectbd.com/konnect/K16.jpg-JoBxO',
  'https://minio-api.apps.konnectbd.com/konnect/K17.jpg-msyOV',
  'https://minio-api.apps.konnectbd.com/konnect/K18.jpg-uGHDL',
  'https://minio-api.apps.konnectbd.com/konnect/K19.jpg-PLiBR',
  'https://minio-api.apps.konnectbd.com/konnect/K20.jpg-taohQ',
];
